import * as Styled from './differentiation.style';

type Props = {
  size?: number;
  marginRight?: number;
  number?: number;
  scale?: boolean;
  fontSize?: number;
  borderRadius?: number;
  'data-selector'?: string;
};

const BlackDiamond = ({
  number,
  size,
  marginRight,
  scale,
  fontSize,
  borderRadius,
  'data-selector': dataSelector,
}: Props) => {
  return (
    <Styled.BlackDiamondWrapper
      $width={size}
      $height={size}
      $marginRight={marginRight}
      $fontSize={fontSize}
      data-selector={dataSelector}
    >
      <Styled.BlackDiamondBackground
        $scale={scale}
        $width={size}
        $height={size}
        $borderRadius={borderRadius}
      />
      {number && (
        <Styled.BlackDiamond $size={size} data-selector={dataSelector}>
          {number}
        </Styled.BlackDiamond>
      )}
    </Styled.BlackDiamondWrapper>
  );
};

export default BlackDiamond;
